export default {
  name: 'American Samoa',
  phonePattern: '6847331234',
  postalCodePattern: '',
  singlePostalCode: '96799',
  postalCodeRegex: '^(96799)$',
  language: '',
  dobFormat: 'DD MM YY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/AS.js